<template>
  <v-form @submit.prevent="buscar">
    <v-card flat class="mx-auto pb-0 mb-0">
      <v-card-text class="pb-0">
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="form.termo"
              outlined
              label="Termo"
              append-icon="mdi-magnify"
              dense
              required
            ></v-text-field>
          </v-col>
          <v-col :cols="isMobile ? 12 : ''" class="mr-2">
            <v-select
              v-model="form.tipo"
              outlined
              :items="tipos"
              item-text="key"
              item-value="key"
              label="Tipo de documento"
              dense
              clearable
            ></v-select>
          </v-col>
          <v-col :cols="isMobile ? 12 : 2" class="mr-2">
            <v-text-field
              v-model="form.ano"
              outlined
              label="Ano"
              dense
              v-mask="'####'"
              clearable
              @keydown.enter="buscar"
            ></v-text-field>
          </v-col>
          <v-col :cols="isMobile ? 12 : ''" class="mr-2">
            <v-select
              v-model="form.relevancia"
              outlined
              label="Relevância"
              :items="relevancias"
              item-text="text"
              item-value="key"
              dense
            ></v-select>
          </v-col>
          <v-col :cols="isMobile ? '' : 'auto'">
            <v-btn block color="primary" type="submit">
              <v-icon class="mr-2">mdi-magnify</v-icon>
              buscar
            </v-btn>
          </v-col>
          <v-col :cols="isMobile ? '' : 'auto'">
            <v-btn block color="orange" dark @click="limpar" class="mx-1">
              limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>
<script>
export default {
  props: { filtrosFormulario: {}, isMobile: { type: Boolean, default: false } },
  data() {
    return {
      form: {
        relevancia: ""
      },
      tipos: [
        { key: "RELATÓRIO / VOTO" },
        { key: "INFORMAÇÃO" },
        { key: "PARECER" },
        { key: "DECISÃO" },
        { key: "ACÓRDÃO" },
        { key: "ATA DE SESSÃO" },
        { key: "JURISPRUDÊNCIA SELECIONADA" }
      ],
      relevancias: [
        { key: "", text: "MAIS RELEVANTES" },
        { key: "&sort=data_sessao&order=asc", text: "MAIS ANTIGOS" },
        { key: "&sort=data_sessao&order=desc", text: "MAIS RECENTES" }
      ]
    };
  },
  mounted() {
    this.form = this.filtrosFormulario;
  },
  watch: {
    filtrosFormulario: {
      handler() {
        this.form = this.filtrosFormulario;
      }
    }
  },
  methods: {
    buscar() {
      if (!this.form.termo) {
        const objeto = {
          text: "Informe um termo para pesquisar na base de processos ",
          color: "error"
        };
        this.$store.commit("SET_SNACK_MESSAGE", objeto);
      } else {
        this.form.historico = false;
        this.form.selected = 0;
        this.form.isMobile = this.isMobile;
        this.$emit("search", this.form);
      }
    },
    limpar() {
      this.form = {};
    }
  }
};
</script>
